class ChartWidgetResultVM extends BaseResultVM {
    groupFields: Array<any>;
    fieldNames: Array<any>;
    result: Array<any>;
    currencyCode: string;
    metricFields: Array<MetricField>;
    xAxisFields: Array<any>;

    warningVisible: KnockoutObservable<boolean>;

    constructor(data) {
        super(data);

        this.groupFields = data?.groupFields ?? [];
        this.fieldNames = data?.fieldNames ?? [];
        this.result = data?.result ?? [];
        this.currencyCode = data.currencyCode;
        this.metricFields = createInstances(MetricField, data?.metricFields ?? []);
        this.xAxisFields = data?.xAxisFields ?? [];

        this.warningVisible = ko.observable(false);        
    }
}